import React, { useState, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  XIcon,
  WhatsappIcon,
  ViberIcon,
  EmailIcon,
  WhatsappShareButton,
  ViberShareButton,
  EmailShareButton,
  TwitterShareButton,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  PinterestIcon,
  PinterestShareButton,
} from 'react-share';
import Modal from '../Modal/Modal';
import { PrimaryButton, SecondaryButton } from '../Button/Button';
import { copyToClipboard } from '../../util/clipboard';

import css from './ShareModal.module.css';

const ShareModal = props => {
  const { isOpen, onCloseModal, onManageDisableScrolling, listing } = props;

  const intl = useIntl();

  const [isCopied, setIsCopied] = useState(false);

  const url = typeof window !== 'undefined' ? `${window.location.origin}/l/${listing.id.uuid}` : '';
  const title = listing?.attributes?.title || '';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
    } catch (e) {
      copyToClipboard(url);
      setIsCopied(true);
    }
  };

  useEffect(() => {
    if (isCopied) {
      const timer = setTimeout(() => setIsCopied(false), 1500);
      return () => clearTimeout(timer);
    }
  }, [isCopied]);

  return (
    <Modal
      id="shareModal"
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      onModalPress={e => {
        e.preventDefault();
        e.stopPropagation();
      }}
      closeButtonMessage={intl.formatMessage({ id: 'Modal.close' })}
      usePortal
    >
      <div className={css.container}>
        <h3 className={css.title}>
          <FormattedMessage id="ListingPage.shareTitle" />
        </h3>

        <div className={css.shareGrid}>
          <FacebookShareButton url={url} title={title}>
            <div className={css.shareItem}>
              <FacebookIcon size={60} borderRadius={8} />
              <span>Facebook</span>
            </div>
          </FacebookShareButton>

          <PinterestShareButton url={url} title={title}>
            <div className={css.shareItem}>
              <PinterestIcon size={60} borderRadius={8} />
              <span>Pinterest</span>
            </div>
          </PinterestShareButton>

          <TwitterShareButton url={url} title={title}>
            <div className={css.shareItem}>
              <XIcon size={60} borderRadius={8} />
              <span>X</span>
            </div>
          </TwitterShareButton>

          <WhatsappShareButton url={url} title={title}>
            <div className={css.shareItem}>
              <WhatsappIcon size={60} borderRadius={8} />
              <span>Whatsapp</span>
            </div>
          </WhatsappShareButton>

          <LinkedinShareButton url={url} title={title}>
            <div className={css.shareItem}>
              <LinkedinIcon size={60} borderRadius={8} />
              <span>Linkedin</span>
            </div>
          </LinkedinShareButton>

          <EmailShareButton url={url} subject={title}>
            <div className={css.shareItem}>
              <EmailIcon size={60} borderRadius={8} />
              <span>E-mail</span>
            </div>
          </EmailShareButton>
        </div>

        <div className={css.linkSection}>
          <input className={css.feedInput} type="text" readOnly value={url} onClick={handleCopy} />
          <PrimaryButton type="button" onClick={handleCopy} className={css.copyButton}>
            <FormattedMessage id={`Global.${isCopied ? 'copied' : 'copy'}`} />
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal;
